import { useEffect, useState, useRef, ChangeEvent } from 'react';
// @ts-ignore
import 'axios-progress-bar/dist/nprogress.css';
import { useAppDispatch } from '../redux/store';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  postThankyouWdw,
  postBookMarkWdw,
  postLoungeFlag,
  removeUserLoungeWdw,
  fetchDisneyWorldLounges,
  fetchAllTaglists,
  lockPostWdw,
  bumpPostWdw,
  fetchCatLoungesWdw,
  stickPostWdw,
  removeImageOverPostWdw,
  fetchUserMenu,
  postSubscribeFromLounge,
} from '../redux/lounges/slice';
import { fetchLoungeDetails } from '../redux/lounges/slice';
import { useSelector } from 'react-redux';
import { selectLounges } from '../redux/lounges/selectors';
import Modal from 'react-modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  AiOutlineTag,
  AiOutlineCloseCircle,
  AiOutlineMessage,
} from 'react-icons/ai';
import { MdMessage } from 'react-icons/md';
import { BiMessageDots } from 'react-icons/bi';

import DmMe from './DmMe';
import TagMe from './TagMe';
import MovePost from './WdwMovePost';
import arrowup from '../assets/img/arrowup.png';
import arrowdown from '../assets/img/arrowdown.png';
import WdwAdvanceEditor from './WdwAdvanceEditor';
import { RichTextEditor } from '@mantine/rte';
import { UploadImage } from '../utils/uploadImage';
import { GET_BASE_URL } from '../constants';


type ToggleMenuPropsType = {
  getBookMark: any;
  getThankYou: any;
  onSubmit: any;
  register: any;
  handleSubmit: any;
  setValue: any;
  isLoading: any;
  editType: any;
  chat_reply_msg: string;
  username?: any;
  userid?: any;
  LoungeId: any;
  pageName: any;
  lock: any;
  chatRoomId: any;
  getStick: any;
  getSubscribe: any;
  // chat_type: any;
};

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    width: '100%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    background: '#F5F5F5',
    transform: 'translate(-50%, -50%)',
  },
};

const replaceModalStyles = {
  ...customStyles,
  content: {
    ...customStyles.content,
    maxWidth: '420px',
    padding: '20px',
  },
};

type FormData = {
  ReasonForReport: string;
  chat_reply_msg: string;
};

function normalizeToolbarUrl(value: string) {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (/^(https?:|mailto:|tel:)/i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export const ToggleMenu: React.FC<ToggleMenuPropsType> = ({
  getBookMark,
  getThankYou,

  onSubmit,
  register,
  handleSubmit,
  setValue,
  isLoading,
  editType,
  username,
  userid,
  LoungeId,
  chat_reply_msg,
  pageName,
  lock,
  chatRoomId,
  getStick,
  getSubscribe,
  // chat_type
}) => {
  const [showIcon, SetShowIcon] = useState<any | string>(true);

  const dispatch = useAppDispatch();
  // const{LoungeId,url}=useParams();
  const { itemDetail, status, stickerItems, commentDataList } =
    useSelector(selectLounges);
  //const { items, status,sortByTime } = useSelector(selectLounges)

  const [thankData, SetThankData] = useState<any | []>([]);
  const [bookMark, SetBookMark] = useState<any | string>(getBookMark);
  const [subscribe, SetSubscribe] = useState<any | string>(getSubscribe);
  const [thankYou, SetThankYou] = useState<any | string>(getThankYou);
  const [Type, setFlagType] = useState<any | string>('C');
  const [LoungeIdd, setLoungeId] = useState<any | string>(LoungeId);

  const loginuserid = localStorage.getItem('user_id');
  const loginuserrank = localStorage.getItem('rank');
  const TAG = localStorage.getItem('Tag');
  const MP = localStorage.getItem('MP');
  const DM = localStorage.getItem('DM');
  const SP = localStorage.getItem('SP');
  const post_editor = localStorage.getItem('editor');
  const [userRank, setUserRank] = useState<any | number>(loginuserrank);
  const [Notify, setIsNotify] = useState<any | string>(); 

  const [isReplaceModalOpen, setIsReplaceModalOpen] = useState(false);
  const [replaceImageDataUrl, setReplaceImageDataUrl] = useState<string | null>(null);
  const [replaceImageError, setReplaceImageError] = useState<string | null>(null);
  const [isReplacingImage, setIsReplacingImage] = useState(false);
  const [replaceFileInputKey, setReplaceFileInputKey] = useState(0);
  const [replaceImageFile, setReplaceImageFile] = useState<File | null>(null);

  const isReplaceImageAdmin =
    loginuserid === '18' ||
    loginuserid === '914' ||
    loginuserid === '38' ||
    loginuserid === '46770';
  const canShowReplaceImageOption = editType === true || isReplaceImageAdmin;
  const [ advancedpost, setAdvancedPost ] = useState(false);

  // thank you
  const onThankyou = (LoungeId: any) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      dispatch<any>(postThankyouWdw({ LoungeId })).then((res: any) => {
        //reset()

        res.payload.data[0].message == 'Added'
          ? SetThankYou(true)
          : SetThankYou(false);
        SetThankData([]);
        SetThankData(res.payload.data[0].thankdata);
        // Notify(toast(res.payload.data[0].message));
        // res.payload[0].isthankyou?.status ==1 && SetThankYou(true)
      });
    }
  };

  const { sortByTime } = useSelector(selectLounges);
  let sortType: any = null;
  let currentPage: any = null;
  let searchValue: any = null;

  const [shortByTime, setShortByTime] = useState<any | string>(
    localStorage.getItem('shortByTime')
  );

  useEffect(() => {
    sortByTime != '' && setShortByTime(sortByTime);
  }, [sortByTime]);

  // remove post from view particular user not delete
  const onRemove = (ban_chat_id: any, RemoveType: string) => {
    console.log('id', ban_chat_id, RemoveType)
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      window.confirm('Are you sure?');
      dispatch<any>(removeUserLoungeWdw({ ban_chat_id, RemoveType })).then(
        (res: any) => {
          window.location.reload();
        }
      );

      dispatch(
        fetchDisneyWorldLounges({
          sortType,
          LoungeId,
          currentPage,
          searchValue,
          shortByTime,
        })
      );
      
    }
  };

  //bookmark a post
  const onBookMark = (LoungeId: any) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      dispatch<any>(postBookMarkWdw({ LoungeId })).then((res: any) => {
        res.payload.data[0].message == 'Added'
          ? SetBookMark(true)
          : SetBookMark(false);
        // Notify(toast(res.payload.data[0].message));
      });
    }
  };

  const [modalIsOpen, setIsOpen] = useState(false);

  let navigate = useNavigate();
  let subtitle: any;
  function openModal() {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      SetShowIcon(false);
      setOnEdit('');
      setFlagType('P');
      setLoungeId(LoungeId);
      setAdvancedPost(false);
      setRichTextValue('');
      setValue('LoungeId', LoungeId);
      setValue('Type', 'P');
      setValue('ReasonForReport', '');
      setValue('chat_reply_msg', undefined);
      setIsOpen(true);
    }
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  const token = localStorage.getItem('token');

  const openReplaceImageModal = () => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      SetShowIcon(false);
      setReplaceImageError(null);
      setReplaceImageDataUrl(null);
      setIsReplaceModalOpen(true);
    }
  };

  const closeReplaceImageModal = () => {
    setIsReplaceModalOpen(false);
    setIsReplacingImage(false);
    setReplaceImageError(null);
    setReplaceImageDataUrl(null);
    setReplaceFileInputKey((prev) => prev + 1);
    setReplaceImageFile(null);
  };

  const handleReplaceImageFile = (event: ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];

    if (!file) {
      setReplaceImageDataUrl(null);
      setReplaceImageFile(null);
      return;
    }

    if (!file.type.match('image.*')) {
      setReplaceImageError('Please select a valid image file.');
      setReplaceImageDataUrl(null);
      setReplaceImageFile(null);
      event.target.value = '';
      return;
    }

    const reader = new FileReader();
    setReplaceImageFile(file);
    reader.onloadend = () => {
      setReplaceImageDataUrl(reader.result as string);
      setReplaceImageError(null);
    };
    reader.readAsDataURL(file);
  };

  const submitReplaceImage = async () => {
    if (!replaceImageFile || isReplacingImage) {
      return;
    }

    if (token == null) {
      navigate('/disneyland/login');
      return;
    }

    setIsReplacingImage(true);
    setReplaceImageError(null);

    try {
      const formData = new FormData();
      formData.append('chat_id', LoungeId);
      formData.append('chat_img', replaceImageFile);

      const response = await fetch(GET_BASE_URL + '/api/v1/replaceImageWdw', {
        method: 'POST',
        headers: {
          Authorization: `bearer ${token}`,
        },
        body: formData,
      });

      let data: any = null;
      try {
        data = await response.json();
      } catch (_error) {
        // Response did not include JSON; rely on HTTP status.
      }

      const statusCode = data?.status ?? response.status;
      if (response.ok && (statusCode === 201 || statusCode === 200)) {
        setTimeout(() => window.location.reload(), 1000);
      } else if (statusCode === 403) {
        setReplaceImageError('You are not allowed to replace this image.');
        setIsReplacingImage(false);
      } else {
        const message =
          (typeof data?.data === 'string' && data?.data) ||
          'Unable to replace the image. Please try again.';
        setReplaceImageError(message);
        setIsReplacingImage(false);
      }
    } catch (error) {
      console.error('replaceImageWdw failed', error);
      setReplaceImageError('Unable to replace the image. Please try again.');
      setIsReplacingImage(false);
    }
  };

  useEffect(() => {
    setValue('Type', Type);
  }, [Type]);

  useEffect(() => {
    setValue('LoungeId', LoungeIdd);
  }, [LoungeIdd]);

  const [onedit, setOnEdit] = useState<any>('');
  const onEdit = (LoungeId: any) => {
    setIsOpen(true);
    setOnEdit(true);
    setFlagType('P');
  };

  // for user tags
  let tagData: any = null;
  const [AllTagData, setAllTagData] = useState<any | String>();
  const [TagList, setTagList] = useState<any | String>(false);
  const openTagdata = () => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      console.log('tag');
      return false;
      dispatch(fetchAllTaglists({ tagData, LoungeId })).then((res: any) => {
        setAllTagData(res.payload);
      });
      setTagList(true);
    }
  };

  const closeTagMe = () => {
    setTagList(false);
  };

  //Dm Box

  const onClickAdvanced = () => {
    setAdvancedPost(!advancedpost)
  }

  const [dmuserId, setdmuserId] = useState<any | String>();
  const [dmusername, setdmuserame] = useState<any | String>();
  const [dmchatId, setdmchatId] = useState<any | String>();
  const [richtextvalue, setRichTextValue] = useState('');
  const richEditorRef = useRef<any>(null);
  const lastRichSelectionRef = useRef<any>(null);
  const toolbarPromptActiveRef = useRef(false);
  const lastToolbarPromptAtRef = useRef(0);
  const [toolbarPrompt, setToolbarPrompt] = useState<{
    kind: 'link' | 'video';
    range: any;
    selectedText: string;
    value: string;
  } | null>(null);

  useEffect(() => {
    setValue('chat_reply_msg_advance', richtextvalue)
  }, [richtextvalue])

  const openDm = (userId: any, username: any, chatId: any) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      console.log('dm');
      return false;
      setdmuserId(userId);
      setdmuserame(username);
      setdmchatId(chatId);
      setDmBox(true);
    }
  };

  useEffect( () => {
    if(chat_reply_msg?.startsWith('<p>')) {
      setRichTextValue(chat_reply_msg);
      setAdvancedPost(true)
      setValue('chat_reply_msg', '')
    }
    else {
      setRichTextValue('');
      setValue('chat_reply_msg', chat_reply_msg)
      setAdvancedPost(false)
    }
  }, [modalIsOpen])

  const openToolbarPrompt = (kind: 'link' | 'video') => {
    const editor = richEditorRef.current?.getEditor?.();
    if (!editor) return;

    const range = editor.getSelection(false) || lastRichSelectionRef.current;
    const selectedText =
      range && range.length > 0
        ? editor.getText(range.index, range.length).trim()
        : '';
    setToolbarPrompt({ kind, range, selectedText, value: '' });
  };

  const applyToolbarPrompt = () => {
    if (!toolbarPrompt) return;
    const editor = richEditorRef.current?.getEditor?.();
    if (!editor) return;

    const url = normalizeToolbarUrl(toolbarPrompt.value);
    if (!url) return;

    const range = toolbarPrompt.range || lastRichSelectionRef.current;
    if (toolbarPrompt.kind === 'video') {
      const cursor = range?.index ?? editor.getLength();
      editor.insertEmbed(cursor, 'video', url, 'user');
      editor.setSelection(cursor + 1, 0, 'silent');
    } else if (range && range.length > 0) {
      editor.formatText(range.index, range.length, 'link', url, 'user');
      editor.setSelection(range.index + range.length, 0, 'silent');
    } else {
      const cursor = range?.index ?? editor.getLength();
      editor.insertText(cursor, url, 'link', url, 'user');
      editor.setSelection(cursor + url.length, 0, 'silent');
    }

    const html = editor.root?.innerHTML;
    if (typeof html === 'string') {
      setRichTextValue(html);
    }
    setToolbarPrompt(null);
  };

  useEffect(() => {
    if (!advancedpost || !modalIsOpen) return;

    const editor = richEditorRef.current?.getEditor?.();
    const onSelectionChange = (range: any) => {
      if (range) {
        lastRichSelectionRef.current = range;
      }
    };
    editor?.on?.('selection-change', onSelectionChange);
    const currentRange = editor?.getSelection?.(false);
    if (currentRange) {
      lastRichSelectionRef.current = currentRange;
    }

    const onToolbarIntent = (event: Event) => {
      const target = event.target as Element | null;
      const button = target?.closest?.(
        '.mw-post-modal .advance-editor .ql-link, .mw-post-modal .advance-editor .ql-video'
      );
      if (!button) return;

      event.preventDefault();
      event.stopPropagation();
      if ('stopImmediatePropagation' in event) {
        event.stopImmediatePropagation();
      }

      const now = Date.now();
      if (event.type === 'click' && now - lastToolbarPromptAtRef.current < 1000) {
        return;
      }
      if (toolbarPromptActiveRef.current) return;

      toolbarPromptActiveRef.current = true;
      lastToolbarPromptAtRef.current = now;
      if (button.classList.contains('ql-link')) {
        openToolbarPrompt('link');
      } else {
        openToolbarPrompt('video');
      }
      window.setTimeout(() => {
        toolbarPromptActiveRef.current = false;
      }, 350);
    };

    const events = ['pointerdown', 'touchstart', 'mousedown', 'click'];
    events.forEach((eventName) => {
      document.addEventListener(eventName, onToolbarIntent, true);
    });

    return () => {
      editor?.off?.('selection-change', onSelectionChange);
      events.forEach((eventName) => {
        document.removeEventListener(eventName, onToolbarIntent, true);
      });
    };
  }, [advancedpost, modalIsOpen]);

  const [openDmBox, setDmBox] = useState<string | any>(false);
  const closeDmBox = () => {
    setDmBox(false);
  };

  // for compose editor
  const openComposeEditor = () => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      navigate('/disneyworld/mw-advance-editor/' + LoungeId);
    }
  };

  // To lock or unlock a post
  const [islock, setIsLock] = useState<any | String>(lock);
  const isLock = (e: any, LoungeId: any, islock: any) => {
    dispatch<any>(lockPostWdw({ LoungeId, islock })).then((res: any) => {
      if (res.payload.data == 'Post Locked') {
        setIsLock('UnLock');
      } else {
        setIsLock('Lock');
      }
      // Notify(toast(res.payload.data));
    });
  };

  // To bump a post
  const isBump = (e: any, chat_id: any, type: any) => {
    dispatch<any>(bumpPostWdw({ chat_id, type })).then((res: any) => {
      dispatch(
        fetchDisneyWorldLounges({
          sortType,
          LoungeId,
          currentPage,
          searchValue,
          shortByTime,
        })
      );
    });
  };

  // To remove image from a post
  const removePostImage = (chat_id: any) => {
    dispatch<any>(removeImageOverPostWdw({ chat_id })).then((res: any) => {
      dispatch(
        fetchDisneyWorldLounges({
          sortType,
          LoungeId,
          currentPage,
          searchValue,
          shortByTime,
        })
      );
    });
  };

  // To Move post

  const [MoveList, setMoveList] = useState<any | String>(false);
  const movePost = () => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      setMoveList(true);
    }
  };

  const closeMovePost = () => {
    setMoveList(false);
  };

  // To Stick post

  const postStick = (type: any, chat_id: any) => {
    dispatch<any>(stickPostWdw({ chat_id, type })).then((res: any) => {
      window.location.reload();
    });
  };

  //post subscribe and unsubscribe
  const subscribePost = (chat_id: any) => {
    if (token == null) {
      navigate('/disneyland/login');
    } else {
      console.log('subscribe');
      return false;
      let suscribeUnsuscribe: any = subscribe;
      dispatch<any>(
        postSubscribeFromLounge({ chat_id, suscribeUnsuscribe })
      ).then((res: any) => {
        console.log(res);
        res.payload.data == 'Removed'
          ? SetSubscribe(true)
          : SetSubscribe(false);

        window.confirm(res.payload.data);
      });
    }
  };

  const onBeforeSubmit = (data: any) => {
    if(!onedit) {
      data.LoungeId = LoungeIdd;
      data.Type = 'P';
      data.ReasonForReport = (data.ReasonForReport || '').trim();
      if(data.ReasonForReport == '')
        return;

      delete data.chat_reply_msg;
      onSubmit(data);
      return;
    }

    if(advancedpost) {
      data.chat_img = false;
      data.chat_reply_msg = richtextvalue;
    }
    else data.chat_img = true;

    if(data.chat_reply_msg == '' || data.chat_reply_msg == '<p><br></p>')
      return;
    
    onSubmit(data);
  }

  return (
    <div className='menu-nav'>
      <div className='dropdown-container' tabIndex={-1}>
        <div className='three-dots'>
          <i className='fa-solid fa-ellipsis-vertical'></i>
        </div>

        {/* for all users thank you,bookmark,remove,DM show menus*/}
        {/* for shahid,admin,914,46770  edit,delete,lock,bump,neverbump,auto bump,sticky, thankyou  show */}
        {/* for 18,914  remove image option  show menus*/}
        {/* if userrank > 84 than flag option will show*/}
        {/*Tag option will manage from admin panel means who user have right his profile will show these option*/}
        {/*MovePost option will manage if tick from admin panel, and user_id (18,914) show  and show on logged user own post */}

        <div className='dropdown'>
          {showIcon == true && (
            <div className='img-drop'>
              <ul className='navbar-nav flex-column p-0 m-0'>
                <li className='nav-item' onClick={() => onThankyou(LoungeId)}>
                  <div className='nav-icon'>
                    <i className='fa-solid fa-star' />
                  </div>
                  {thankYou == true ? (
                    <span>Thanked</span>
                  ) : (
                    <span>Thank You!</span>
                  )}
                </li>

                <li className='nav-item' onClick={() => onBookMark(LoungeId)}>
                  <div className='nav-icon'>
                    <i className='fa-solid fa-bookmark' />
                  </div>
                  {bookMark == true ? (
                    <span>Bookmarked</span>
                  ) : (
                    <span>Bookmark</span>
                  )}
                </li>
                {/*                 <li
                  className='nav-item'
                  onClick={(e) => {
                    if (
                      window.confirm(
                        'This will send you email notifications (only if your email is correct in your profile) when people commnet on this post. to unsubscribe go to your MyMW page and click on Subscriptions.'
                      )
                    )
                      subscribePost(LoungeId);
                  }}
                >
                  <div className='nav-icon'>
                    <i className='fa-solid fa-bell' />
                  </div>

                  {subscribe == true ? (
                    <span>Subscribe</span>
                  ) : (
                    <span>Unsubscribe</span>
                  )}
                </li> */}

                <li
                  className='nav-item'
                  onClick={() => onRemove(LoungeId, 'P')}
                >
                  <div className='nav-icon'>
                    <i className='fa-solid fa-remove' />
                  </div>
                  <span>
                    Remove
                    <p style={{ fontSize: '8px' }}>Hide From Your Timeline</p>
                  </span>
                </li>

                {editType == true ? (
                  <>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-edit' />
                      </div>
                      <span onClick={() => onEdit(LoungeId)}>Edit</span>
                    </li>

                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-trash' />
                      </div>
                      <span onClick={() => onRemove(LoungeId, 'D')}>
                        Delete
                      </span>
                    </li>
                  </>
                ) : (
                  <>
                    {/*          <li className='nav-item'>
                      <div className='nav-icon'>
                        <MdMessage></MdMessage>
                      </div>
                      <span onClick={() => openDm(userid, username, LoungeId)}>
                        DM
                      </span>
                    </li> */}
                  </>
                )}

                {/* {userRank > 84 ? ( */}
                  <>
                    <li className='nav-item' onClick={openModal}>
                      <div className='nav-icon'>
                        <i className='fa-solid fa-flag' />
                      </div>
                      <span>Flag/Report</span>
                    </li>
                  </>
                {/* ) : (
                  <></>
                )} */}

                {loginuserid == '18' ||
                loginuserid == '914' ||
                TAG == 'true' ? (
                  <>
                    {/*            <li className='nav-item'>
                      <div className='nav-icon'>
                        <AiOutlineTag></AiOutlineTag>
                      </div>
                      <span onClick={openTagdata}>Tag Me</span>
                    </li> */}
                  </>
                ) : (
                  <></>
                )}

                {loginuserid == userid ||
                loginuserid == '18' ||
                loginuserid == '914' ||
                MP == 'true' ? (
                  <>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-cog' />
                      </div>
                      <span onClick={movePost}>Move Post</span>
                    </li>
                  </>
                ) : (
                  <></>
                )}

                {canShowReplaceImageOption && (
                  <li className='nav-item' onClick={openReplaceImageModal}>
                    <div className='nav-icon'>
                      <i className='fa fa-image' />
                    </div>
                    <span>Replace Image</span>
                  </li>
                )}

                {loginuserid == '18' || loginuserid == '914' ? (
                  <>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-times-circle' />
                      </div>
                      <span
                        onClick={(e) => {
                          if (
                            window.confirm(
                              'This will remove post image Are you sure?'
                            )
                          )
                            removePostImage(LoungeId);
                        }}
                      >
                        Remove Image
                      </span>
                    </li>
                  </>
                ) : (
                  <></>
                )}

                {SP == 'true' ? (
                  <>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-cogs' />
                      </div>
                      <span
                        onClick={(e) => {
                          if (
                            window.confirm(
                              'Do you want to Stick/Unstick this post?'
                            )
                          )
                            postStick(getStick, LoungeId);
                        }}
                      >
                        {getStick}
                      </span>
                    </li>
                  </>
                ) : (
                  <></>
                )}

                {/* {post_editor && 
                  <li className='nav-item'>
                    <div className='nav-icon'>
                      <BiMessageDots></BiMessageDots>
                    </div>
                    <span onClick={openComposeEditor}>
                      Edit With Composer
                    </span>
                  </li>
                } */}

              {
                editType != true && (loginuserid == '18' ||
                  loginuserid == '914' ||
                  loginuserid == '38' ||
                  loginuserid == '46770') && 
                  <>
                    <li className='nav-item'>
                        <div className='nav-icon'>
                          <i className='fa fa-edit' />
                        </div>
                        <span onClick={() => onEdit(LoungeId)}>Edit</span>
                      </li>

                      <li className='nav-item'>
                        <div className='nav-icon'>
                          <i className='fa fa-trash' />
                        </div>
                        <span onClick={() => onRemove(LoungeId, 'D')}>
                          Delete
                        </span>
                      </li>
                  </>
                }

                {loginuserid == '18' ||
                loginuserid == '914' ||
                loginuserid == '38' ||
                loginuserid == '46770' ? (
                  <>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-life-ring' />
                      </div>
                      <span
                        onClick={(e) => {
                          if (
                            window.confirm(
                              'Do you want to Lock/Unlock this post?'
                            )
                          )
                            isLock(e, LoungeId, islock);
                        }}
                      >
                        {islock}
                      </span>
                    </li>

                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-plus-square' />
                      </div>
                      <span
                        onClick={(e) => {
                          if (
                            window.confirm(
                              'Do you want to to make this post Bump?'
                            )
                          )
                            isBump(e, LoungeId, 'up');
                        }}
                      >
                        Bump
                      </span>
                    </li>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-square' />
                      </div>
                      <span
                        onClick={(e) => {
                          if (
                            window.confirm(
                              'Do you want to to make this post Never Bump?'
                            )
                          )
                            isBump(e, LoungeId, 'never');
                        }}
                      >
                        Never Bump
                      </span>
                    </li>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-check-square' />
                      </div>
                      <span
                        onClick={(e) => {
                          if (
                            window.confirm(
                              'Do you want to to make this post  Bump?'
                            )
                          )
                            isBump(e, LoungeId, 'auto');
                        }}
                      >
                        Auto Bump
                      </span>
                    </li>
                    <li className='nav-item'>
                      <div className='nav-icon'>
                        <i className='fa fa-minus-square' />
                      </div>
                      <span
                        onClick={(e) => {
                          if (
                            window.confirm(
                              'Do you want to to make this post Bump?'
                            )
                          )
                            isBump(e, LoungeId, 'down');
                        }}
                      >
                        Bump Down
                      </span>
                    </li>
                  </>
                ) : (
                  <></>
                )}
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* <ToastContainer autoClose={3000} /> */}

      {/* tag me starts here  */}

      <TagMe
        isOpen={TagList}
        isClosed={closeTagMe}
        TagDatas={AllTagData}
        chatId={LoungeId}
        Page={pageName}
      />

      {/* tag me ends here  */}

      {/* for dm message  */}
      <DmMe
        isOpen={openDmBox}
        isClosed={closeDmBox}
        LoungeId={''}
        register={''}
        handleSubmit={''}
        onSubmit={''}
        setValue={''}
        isSubmitted={true}
        user_id={dmuserId}
        userName={dmusername}
        chatId={dmchatId}
        type={''}
      />

      {/* dm message modal ends here  */}

      {/*  flag modal start  */}
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        className='mw-post-modal'
        overlayClassName='mw-post-modal-overlay'
        contentLabel='Example Modal'
      >
        <form
          className='space-y-6 mw-post-modal-form'
          onSubmit={handleSubmit(onBeforeSubmit)}
          method='POST'
        >
          <div className='row'>
            <div className='box-t-1'>
              {onedit != '' ? (
                <h6 style={{ fontSize: '1rm', fontWeight: 400, color: 'red' }}>
                  Edit Post
                </h6>
              ) : (
                <h6 style={{ fontSize: '1rm', fontWeight: 400, color: 'red' }}>
                  Report
                </h6>
              )}

              <div className='close-p' onClick={closeModal}>
                <i className='fa fa-close my-b' />
              </div>
              <div className='boxwidth'>
                <div className='box-ttt'>
                  {onedit != '' ? (
                    <div>

                      {post_editor == 'true' && (
                        <div className="advance-radio-gruop">
                          <div>
                            <input type="radio" id="default" checked={!advancedpost} onClick={onClickAdvanced}></input>
                            <label htmlFor="default">Default Post</label>
                          </div>
                          
                          <div>
                            <input type="radio" id="advanced" checked={advancedpost} onClick={onClickAdvanced}></input>
                            <label htmlFor="advanced">Advanced Post</label>
                          </div>
                        </div>
                      )}

                      {!advancedpost ? (
                      <>
                        <textarea
                          rows={3}
                          cols={60}
                          className='mw-edit-post-textarea'
                          {...register('chat_reply_msg')}
                          /* {...register("Type")} {...register("LoungeId")} */
                        />
                      </>
                      ) : ( 
                        <>
                          <div className="advance-editor">
                            <RichTextEditor 
                            ref={richEditorRef}
                            value={richtextvalue}
                            onChange={setRichTextValue} 
                            />
                            {toolbarPrompt && (
                              <div className="mw-toolbar-url-prompt">
                                <label htmlFor="mw-wdw-toolbar-url-input">
                                  {toolbarPrompt.kind === 'video'
                                    ? 'Video URL'
                                    : toolbarPrompt.selectedText
                                      ? 'Link selected text'
                                      : 'Link URL'}
                                </label>
                                <div className="mw-toolbar-url-row">
                                  <input
                                    id="mw-wdw-toolbar-url-input"
                                    type="url"
                                    autoFocus
                                    value={toolbarPrompt.value}
                                    placeholder="https://mousewait.com/disneyland/sticker-fairy-deal"
                                    onChange={(event) =>
                                      setToolbarPrompt({
                                        ...toolbarPrompt,
                                        value: event.target.value,
                                      })
                                    }
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter') {
                                        event.preventDefault();
                                        applyToolbarPrompt();
                                      }
                                      if (event.key === 'Escape') {
                                        event.preventDefault();
                                        setToolbarPrompt(null);
                                      }
                                    }}
                                  />
                                  <button type="button" onClick={applyToolbarPrompt}>
                                    Apply
                                  </button>
                                  <button type="button" onClick={() => setToolbarPrompt(null)}>
                                    Cancel
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </>)
                      }
                    </div>
                  ) : (
                    <textarea
                      rows={3}
                      cols={60}
                      placeholder='write reason for reporting'
                      {...register('ReasonForReport')}

                      /* {...register("Type")} {...register("LoungeId")} */
                    />
                  )}

                  {/*    <input type='hidden' setValue={Type} {...register('Type')} />
                  <input
                    type='hidden'
                    setValue={LoungeId}
                    {...register('LoungeId')}
                  /> */}
                  <div className='mw-post text-center'>
                    {isLoading == true ? (
                      <input className='MW-btn' type='Submit' value={onedit ? 'Edit' : 'Report'} style={{backgroundColor: '#0d6efd'}}/>
                    ) : (
                      <input className='MW-btn' type='Submit' value={onedit ? 'Edit' : 'Report'} style={{backgroundColor: '#0d6efd'}}/>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal>
      {/*  flag modal end  */}

      <Modal
        isOpen={isReplaceModalOpen}
        onRequestClose={closeReplaceImageModal}
        style={replaceModalStyles}
        contentLabel='Replace Image'
      >
        <div className='row'>
          <div className='box-t-1'>
            <h6 style={{ fontSize: '1rem', fontWeight: 400, color: 'red' }}>
              Replace Image
            </h6>
            <div className='close-p' onClick={closeReplaceImageModal}>
              <i className='fa fa-close my-b' />
            </div>

            <div className='boxwidth'>
              <div className='box-ttt'>
                <div className='replace-image-input'>
                  <input
                    key={replaceFileInputKey}
                    type='file'
                    accept='image/*'
                    onChange={handleReplaceImageFile}
                  />
                </div>

                {replaceImageError && (
                  <p style={{ color: 'red', marginTop: '8px' }}>
                    {replaceImageError}
                  </p>
                )}

                {replaceImageDataUrl && (
                  <div style={{ marginTop: '12px' }}>
                    <img
                      src={replaceImageDataUrl}
                      alt='Selected preview'
                      style={{ maxWidth: '100%', borderRadius: '4px' }}
                    />
                  </div>
                )}

                <div
                  className='mw-post text-center'
                  style={{ marginTop: '16px' }}
                >
                  <button
                    type='button'
                    className='MW-btn'
                    style={{ backgroundColor: '#0d6efd', marginRight: '8px' }}
                    disabled={!replaceImageFile || isReplacingImage}
                    onClick={submitReplaceImage}
                  >
                    {isReplacingImage ? 'Replacing...' : 'Replace'}
                  </button>
                  <button
                    type='button'
                    className='MW-btn'
                    onClick={closeReplaceImageModal}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* move post starts here  */}

      <MovePost
        isOpen={MoveList}
        isClosed={closeMovePost}
        TagDatas={''}
        chatId={LoungeId}
        Page={''}
        chatRoomId={chatRoomId}
      />

      {/* move post ends here  */}
    </div>
  );
};
